export const IMAGE_PREFIX = 'image';
export const TAG_PREFIX = 'tag';
